// The Gravando AI mark: a green "G" (open stroked ring) with the red record dot at
// its tip. Ported 1:1 from the Android app's ic_logo vector (res/drawable/ic_logo.xml)
// so the Hub and the mobile app share the exact same logo geometry and colours.
export default function BrandLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Gravando AI"
    >
      {/* the G */}
      <path
        d="M73,40 A26,26 0 1 0 73,64 L73,55 L57,55"
        stroke="#0e8c5a"
        strokeWidth={11}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* record dot at the opening */}
      <circle cx={73} cy={40} r={6.5} fill="#e5342a" />
    </svg>
  );
}
